import { createPortal } from "react-dom"

const Portal: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return createPortal(children, document.getElementById("portals"))
}

export default Portal
